import request from '@/utils/request'
const preFixUrl = '/health'
// 上传
/**
 *
 * @param {*} data
 * @returns
 */
export const getUploadParams = data => {
  return request({
    url: `${preFixUrl}/BackArticle/getUploadSign`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}

/**
 *
 * @param {*} data
 * @returns
 */
export const getImageUrl = data => {
  return request({
    url: `${preFixUrl}/BackArticle/getImageUrl`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
